import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import moment from 'moment-timezone';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getGroups, getGroupDetail } from '../../actions/Groups';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import { getOptionShops } from '../../actions/Options';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { getGochisByGochiCode, useGochiCode } from '../../libs/apis/GochiApi';
import UseGochiButton from '../../components/atoms/UseGochiButton';
import taxRatePercent from '../../constants/taxRate';
import usageTypes from '../../constants/UsageType';
import { getTextBySystem as gts } from '../../utils';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  rowTitle: {
    // marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  },
  tit: {
    padding: 10,
    margin: '0',
    marginBottom: '20px',
    paddingBottom: '10px',
    paddingLeft: '0px',
    borderBottom: '1px solid'
  },
  textField: {
    padding: '0px',
    width: '300px',
    marginRight: '20px'
  },
  textField1: {
    padding: '0px',
    width: '200px',
    marginRight: '20px'
  },
  textField2: {
    padding: '0px',
    width: '100px'
  },
  textField3: {
    padding: '0px',
    width: '100px',
    margin: '0 0 0 10px'
  },
  rowForm: {
    marginBottom: '10px'
  },
  textRed: {
    color: 'red'
  },
  gochiError: {
    fontSize: '13px',
    padding: 10,
    margin: '0 10px',
    paddingBottom: '10px',
    color: 'red'
  },
  gochiError1: {
    fontSize: '13px',
    padding: '10px 0',
    paddingBottom: '10px',
    color: 'red'
  },
  textDes: {
    padding: 20,
    fontSize: '13px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups,
      shops: state.shops.shops
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isChangeSuccess', 'updateIsChangeSuccess', false),
  withState('shopId', 'setShopId', 0),
  withState('shopIdAdd', 'setShopIdAdd', 0),
  withState('shops', 'setShops', []),
  withState('openResult', 'updateOpenResult', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('redirectPath', 'setRedirectPath', '/shops_shop'),
  withState('gochiDate', 'setGochiDate', () => {
    return moment().format('YYYY-MM-DDTHH:mm:ss');
  }),
  withState('inputFields', 'setInputFields', [
    {
      useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
      gochiCode: '',
      gochiInfo: [],
      gochiError: ''
    },
    {
      useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
      gochiCode: '',
      gochiInfo: [],
      gochiError: ''
    },
    {
      useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
      gochiCode: '',
      gochiInfo: [],
      gochiError: ''
    },
    {
      useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
      gochiCode: '',
      gochiInfo: [],
      gochiError: ''
    },
    {
      useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
      gochiCode: '',
      gochiInfo: [],
      gochiError: ''
    }
  ]),
  withState('totalGochi', 'setTotalGochi', 0),
  withState('totalAmount', 'setTotalAmount', 0),
  withState('canAdd', 'setCanAdd', true),
  withState('errorShop', 'setErrorShop', true),
  withState('resultData', 'setResultData', [
    { message: '', error: false, gochiCode: '' }
  ]),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getOptionShops().then(data => {
        this.props.checkSession(data);
        this.props.setShops(data.payload.list);
      });
      this.props.setShopId(0);
      this.props.setShopIdAdd(0);
      if (this.props.shopId) {
        this.props.setShopIdAdd(this.props.shopId);
      }
      this.props.setInputFields([
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        }
      ]);
      this.props.setResultData([]);
    }
  })
);

const NotificationsGroup = enhance(
  ({
    classes,
    openProgress,
    handleRedirect,
    updateOpenProgress,
    loading,
    updateLoading,
    isChangeSuccess,
    shopIdAdd,
    setShopIdAdd,
    shops,
    shopId,
    inputFields,
    setInputFields,
    totalGochi,
    setTotalGochi,
    totalAmount,
    setTotalAmount,
    canAdd,
    setCanAdd,
    openResult,
    updateOpenResult,
    resultData,
    setResultData,
    resultMessage,
    errorShop,
    setErrorShop,
    account
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;

    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;

    const getShopOptions = () => {
      const shopOptions = [];
      const tmpObj = { label: '', value: '0' };
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId)
        });
      });
      return shopOptions.length > 0 ? { ...shopOptions, tmpObj } : shopOptions;
    };

    const useAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      let nothing = true;
      const nData = [];
      try {
        for (let i = 0; i < inputFields.length; i += 1) {
          const info = inputFields[i];
          if (Object.keys(info.gochiInfo).length > 0 && info.useDate) {
            // eslint-disable-next-line no-await-in-loop
            await useGochiCode({
              gochiCode: info.gochiCode,
              useDate: moment(info.useDate).format('YYYY-MM-DDTHH:mm:ss'),
              shopId: null,
              useAmount: info.useAmount,
              useForShopId: shopIdAdd,
              taxRate: info.taxRate
            })
              .then(data => {
                if (data.status === 403) {
                  alert('セッションが切れました。\n再度ログインしてください。');
                  handleRedirect('/');
                }
                let er = true;
                if (data.status === 200) {
                  er = false;
                }
                nData.push({
                  message: '',
                  error: er,
                  gochiCode: info.gochiCode
                });
                setResultData(nData);
              })
              .catch(e => {
                if (e.response.status === 403) {
                  alert('セッションが切れました。\n再度ログインしてください。');
                  handleRedirect('/');
                }
                nData.push({
                  message: '',
                  error: true,
                  gochiCode: info.gochiCode
                });
                setResultData(nData);
              });
            nothing = false;
          }
        }
      } catch (error) {
        console.log('error', error);
      }

      if (nothing) {
        setResultData([
          {
            message: isFukuoka
              ? 'コードを入力してください。'
              : 'ごちコードを入力してください。',
            error: true,
            gochiCode: ''
          }
        ]);
      }
      updateOpenResult(true);
      updateLoading(false);
      updateOpenProgress(false);
    };

    const addFields = () => {
      const newfield = {
        useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
        gochiCode: '',
        gochiInfo: ''
      };
      const dataAdd = [...inputFields, newfield];
      setInputFields(dataAdd);
      if (dataAdd.length > 9) {
        setCanAdd(false);
      }
    };

    const removeFields = index => {
      const dataDel = [...inputFields];
      dataDel.splice(index, 1);
      setInputFields(dataDel);
      let numGochi = 0;
      let amountGochi = 0;
      dataDel.forEach(info => {
        if (Object.keys(info.gochiInfo).length > 0) {
          numGochi += 1;
          amountGochi += parseInt(info.gochiInfo.gochiAmount, 10);
        }
      });
      setTotalGochi(numGochi);
      setTotalAmount(amountGochi);
      if (dataDel.length < 10) {
        setCanAdd(true);
      }
    };

    const removeInputAmount = index => {
      const dataDel = [...inputFields];
      const regEx = new RegExp('[,|.]');
      dataDel[index].useAmount = '';
      dataDel[index].gochiError = '※任意の金額を入力してください';
      setInputFields(dataDel);
      let numGochi = 0;
      let amountGochi = 0;
      dataDel.forEach(info => {
        if (Object.keys(info.gochiInfo).length > 0) {
          if (info.gochiInfo.gochiType === 'LOCAL_WALLET') {
            if (
              info.useAmount !== undefined &&
              info.useAmount !== '' &&
              info.useAmount > 0 &&
              !Number.isNaN(info.useAmount) &&
              !regEx.test(`${info.useAmount}+""`) &&
              info.useAmount <= info.gochiInfo.gochiAmount
            ) {
              numGochi += 1;
              amountGochi += parseInt(info.useAmount, 10);
            }
          } else {
            numGochi += 1;
            amountGochi += parseInt(info.gochiInfo.gochiAmount, 10);
          }
        }
      });
      setTotalGochi(numGochi);
      setTotalAmount(amountGochi);
    };

    const handleFormChangeAmount = (index, event) => {
      const dataChange = [...inputFields];
      const regEx = new RegExp('[,|.]');
      dataChange[index][event.target.name] = event.target.value.trim();
      setInputFields(dataChange);
      let numGochi = 0;
      let amountGochi = 0;
      dataChange.forEach(info => {
        if (Object.keys(info.gochiInfo).length > 0) {
          if (info.gochiInfo.gochiType === 'LOCAL_WALLET') {
            if (
              info.useAmount !== undefined &&
              info.useAmount !== '' &&
              info.useAmount > 0 &&
              !Number.isNaN(info.useAmount) &&
              !regEx.test(`${info.useAmount}+""`) &&
              info.useAmount <= info.gochiInfo.gochiAmount
            ) {
              numGochi += 1;
              amountGochi += parseInt(info.useAmount, 10);
            }
          } else {
            numGochi += 1;
            amountGochi += parseInt(info.gochiInfo.gochiAmount, 10);
          }
        }
      });
      setTotalGochi(numGochi);
      setTotalAmount(amountGochi);
    };

    const validInputAmount = (index, event) => {
      const dataChange = [...inputFields];
      const inputValue = event.target.value;
      const regEx = new RegExp('[,|.]');
      dataChange[index].gochiError = '';
      if (
        inputValue === undefined ||
        inputValue === '' ||
        inputValue <= 0 ||
        regEx.test(`${inputValue}+""`)
      ) {
        dataChange[index].gochiError = '※利用可能額の範囲内で入力してください';
      }
      if (inputValue > dataChange[index].gochiInfo.gochiAmount) {
        dataChange[index].gochiError = '※利用可能額の範囲内で入力してください';
      }
      setInputFields(dataChange);
    };

    const handleFormChange = (index, event) => {
      const dataChange = [...inputFields];
      dataChange[index][event.target.name] = event.target.value.trim();
      setInputFields(dataChange);
      if (!shopIdAdd) {
        setErrorShop(
          isFukuoka ? '教室を選択してください。' : '店舗をご選択ください。'
        );
      } else {
        setErrorShop('');
      }
    };

    const handleFormChangeTaxRate = (index, event) => {
      const dataChange = [...inputFields];
      dataChange[index][event.target.name] = parseFloat(
        event.target.value.trim()
      );
      setInputFields(dataChange);
    };

    const closeAction = () => {
      setInputFields([
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        },
        {
          useDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          gochiCode: '',
          gochiInfo: [],
          gochiError: ''
        }
      ]);
      setTotalGochi(0);
      setTotalAmount(0);
      setResultData([]);
      updateOpenResult(false);
      setCanAdd(true);
    };

    const getGochi = (index, gochiCode) => {
      if (gochiCode.length === 5) {
        const tempData = [...inputFields];
        getGochisByGochiCode({
          gochiCode,
          useForShopId: shopIdAdd,
          useDateGet: moment(tempData[index].useDate).format(
            'YYYY-MM-DDTHH:mm:ss.000'
          )
        })
          .then(data => {
            const newData = [...inputFields];
            if (data.status === 200) {
              newData[index].gochiInfo = data.data;
              newData[index].gochiError = '';
              if (
                newData[index].gochiInfo.gochiAmount === 0 &&
                newData[index].gochiInfo.gochiType === 'LOCAL_WALLET'
              ) {
                newData[index].gochiError =
                  '利用可能額が0円です。消込みできません。';
              }
              if (!isFukuoka) {
                if (newData[index].gochiInfo.usageType === USAGE_TYPE_MENU) {
                  newData[index].taxRate = newData[index].gochiInfo.taxRate;
                } else {
                  newData[index].taxRate = taxRatePercent.TAX_RATE_10_PERCENT;
                }
              }
              setInputFields(newData);
            } else {
              newData[index].gochiError = 'エラーが発生しました。';
              setInputFields(newData);
            }
            let numGochi = 0;
            let amountGochi = 0;
            inputFields.forEach(info => {
              if (Object.keys(info.gochiInfo).length > 0) {
                if (info.gochiInfo.gochiType === 'LOCAL_WALLET') {
                  if (
                    info.useAmount !== undefined &&
                    info.useAmount !== '' &&
                    info.useAmount > 0
                  ) {
                    numGochi += 1;
                    amountGochi += parseInt(info.useAmount, 10);
                  }
                } else {
                  numGochi += 1;
                  amountGochi += parseInt(info.gochiInfo.gochiAmount, 10);
                }
              }
            });
            setTotalGochi(numGochi);
            setTotalAmount(amountGochi);
          })
          .catch(e => {
            if (e.response.status === 403) {
              alert('セッションが切れました。\n再度ログインしてください。');
              handleRedirect('/');
            }
            const newData = [...inputFields];
            if (
              e.response.status === 400 &&
              e.response.data.errorInfo.code ===
                'exception.errors.not.found.resource'
            ) {
              newData[index].gochiError = '消込済みです';
            } else if (
              e.response.status === 400 &&
              e.response.data.errorInfo.code ===
                'exception.errors.unexpeced.exception'
            ) {
              newData[index].gochiError = isFukuoka
                ? 'クーポン検索に失敗しました。'
                : 'ごち検索に失敗しました。';
            } else {
              newData[index].gochiError = 'エラーが発生しました。';
            }
            newData[index].gochiInfo = [];
            setInputFields(newData);
          });
      } else {
        const newData = [...inputFields];
        newData[index].gochiError = '';
        newData[index].gochiInfo = [];
        let numGochi = 0;
        let amountGochi = 0;
        newData.forEach(info => {
          if (Object.keys(info.gochiInfo).length > 0) {
            if (info.gochiInfo.gochiType === 'LOCAL_WALLET') {
              if (
                info.useAmount !== undefined &&
                info.useAmount !== '' &&
                info.useAmount > 0
              ) {
                numGochi += 1;
                amountGochi += parseInt(info.useAmount, 10);
              }
            } else {
              numGochi += 1;
              amountGochi += parseInt(info.gochiInfo.gochiAmount, 10);
            }
          }
        });
        setTotalGochi(numGochi);
        setTotalAmount(amountGochi);
        setInputFields(newData);
      }
    };

    const getUseDate = (index, event) => {
      const dataChange = [...inputFields];
      dataChange[index][event.target.name] = event.target.value.trim();
      setInputFields(dataChange);
      const gochiInfoTemp = dataChange[index].gochiInfo;
      if (Object.keys(gochiInfoTemp).length > 0) {
        if (gochiInfoTemp.gochiType === 'LOCAL_WALLET') {
          getGochi(index, dataChange[index].gochiCode);
        }
      }
    };

    const progressOkAction = () => {
      if (isChangeSuccess) {
        updateOpenProgress(false);
      } else {
        updateOpenProgress(false);
      }
    };

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="ごちコード消込" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            {gts('ごちコード消込', educateSystem)}
          </Typography>
          <Paper className={classes.paperWhite}>
            <div className={classes.searchForm}>
              <div className={classes.rowForm}>
                <ReactSelectMaterialUi
                  required
                  label={isFukuoka ? '教室名*' : '店舗名*'}
                  className={classes.textField}
                  defaultValue={String(shopId)}
                  value={String(shopIdAdd)}
                  options={getShopOptions()}
                  onChange={v => {
                    setShopIdAdd(Number(v));
                    if (Number(v)) {
                      setErrorShop('');
                    }
                    closeAction();
                  }}
                  SelectProps={{
                    isClearable: true,
                    msgNoOptionsMatchFilter:
                      '名前が部分一致する店舗がありません'
                  }}
                />
                <div className={classes.textRed}>{errorShop}</div>
              </div>
            </div>
            <div className={classes.tit}>
              {`合計: ${totalGochi}件 ${totalAmount}円`}
            </div>
            {inputFields.map((input, index) => {
              return (
                <div className={classes.gochiCode}>
                  <div className={classes.searchForm}>
                    <TextField
                      label="利用日"
                      type="datetime-local"
                      className={classes.textField1}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      onKeyDown={e => e.preventDefault()}
                      name="useDate"
                      value={input.useDate}
                      onChange={e => {
                        handleFormChange(index, e);
                        getUseDate(index, e);
                      }}
                    />
                    <TextField
                      name="gochiCode"
                      label={isFukuoka ? 'コード' : 'ごちコード'}
                      placeholder={isFukuoka ? 'コード' : 'ごちコード'}
                      value={input.gochiCode}
                      className={classes.textField2}
                      margin="normal"
                      onChange={e => {
                        handleFormChange(index, e);
                        getGochi(index, e.target.value.trim());
                      }}
                    />
                    <Button
                      className={classes.btRemove}
                      onClick={() => removeFields(index)}
                      color="primary"
                    >
                      X
                    </Button>
                  </div>
                  {Object.keys(input.gochiInfo).length > 0 ? (
                    <div className={classes.gochiInfo}>
                      {((input.gochiInfo.gochiType === 'LOCAL_WALLET' &&
                        input.gochiInfo.gochiAmount !== 0) ||
                        input.gochiInfo.gochiType !== 'LOCAL_WALLET') && (
                        <>
                          {`${isFukuoka ? 'コース名：' : 'メニュー名: '}${
                            input.gochiInfo.menuName
                          }`}
                          <br />
                          {`利用者: ${input.gochiInfo.gochiUserName}`}
                          <br />
                        </>
                      )}
                      {input.gochiInfo.gochiType === 'LOCAL_WALLET' ? (
                        <div>
                          {input.gochiInfo.gochiAmount !== 0 && (
                            <>
                              <div>
                                {`利用可能額：${input.gochiInfo.gochiAmount.toLocaleString()}円`}
                                <br />
                              </div>
                              利用金額（税込）：
                              <TextField
                                name="useAmount"
                                type="number"
                                placeholder="例) 1000"
                                value={input.useAmount}
                                className={classes.textField3}
                                inputProps={{ inputMode: 'numeric' }}
                                margin="normal"
                                onChange={e => {
                                  handleFormChangeAmount(index, e);
                                  validInputAmount(index, e);
                                }}
                              />
                              <Button
                                className={classes.btRemove}
                                onClick={() => removeInputAmount(index)}
                                color="primary"
                              >
                                X
                              </Button>
                            </>
                          )}
                          <div className={classes.gochiError1}>
                            {input.gochiError}
                          </div>
                        </div>
                      ) : (
                        `金額（税込）: ${input.gochiInfo.gochiAmount.toLocaleString()}円`
                      )}
                      {!isFukuoka &&
                        (!input.gochiInfo.menuId ||
                          input.gochiInfo.usageType === USAGE_TYPE_VOUCHER ||
                          input.gochiInfo.usageType === USAGE_TYPE_COMBO) && (
                          <div>
                            <Typography
                              style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: 'rgba(0, 0, 0, 0.54)'
                              }}
                            >
                              消費税区分
                            </Typography>
                            <RadioGroup
                              row
                              value={input.taxRate}
                              onChange={e => {
                                handleFormChangeTaxRate(index, e);
                              }}
                              name="taxRate"
                            >
                              <FormControlLabel
                                value={taxRatePercent.TAX_RATE_10_PERCENT}
                                control={<Radio color="primary" />}
                                label="10%対象"
                              />
                              <FormControlLabel
                                value={taxRatePercent.TAX_RATE_8_PERCENT}
                                control={<Radio color="primary" />}
                                label="8%対象"
                                style={{ marginLeft: 20 }}
                              />
                            </RadioGroup>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className={classes.gochiError}>{input.gochiError}</div>
                  )}
                </div>
              );
            })}
            <div className={classes.horizotalLine} />
            {!isFukuoka && (
              <div className={classes.textDes}>
                ※金額や枚数の指定が必要な場合は、こちらでは使用済みには対応できません。恐れ入りますが、お問合せください。
              </div>
            )}
            <div className={classes.searchForm}>
              <Button onClick={addFields} color="primary" disabled={!canAdd}>
                {isFukuoka ? 'コード消込行追加' : 'ごちコード行追加'}
              </Button>
              <UseGochiButton
                onClickAction={useAction}
                closeAction={closeAction}
                name="消込"
                resultData={resultData}
                openResult={openResult}
                updateOpenResult={updateOpenResult}
                classes={classes}
                isFukuoka={isFukuoka}
              />
            </div>
            <ProgressDialog
              openProgress={openProgress}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
            />
          </Paper>
        </main>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(NotificationsGroup));
